<onyx-section [heading]="`${I18N}.heading`" [count]="form().length">
  <div class="container">
    <app-documents-form-list [documents]="documents()" [form]="form()">
    </app-documents-form-list>

    <onyx-button
      variant="outlined"
      [size]="32"
      leftIcon="add-outlined"
      (click)="addDocument()"
    >
      {{ 'labels.add' | translate }}
    </onyx-button>
  </div>
</onyx-section>
